<template>
  <CRow>
    <CCol cols="12" md="12" lg="12">
      <CRow>
        <CCol cols="12" md="12" lg="12">
          <b-button variant="primary" class="mb-4" v-b-modal.modal-input>
            <CIcon name="cil-plus" />
            {{ $store.state.table.tambahModal }}
          </b-button>
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
            <template #Actions="{ item }">
              <td>
                <b-button
                  variant="warning"
                  class="mr-1"
                  v-c-tooltip.hover.click="$store.state.table.tooltipEdit"
                  v-b-modal.modal-edit
                  @click="(data = item), (edit = !edit)"
                  :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                  ><CIcon name="cil-pencil" /> {{ item.actions }}</b-button
                >
                <b-button
                  variant="danger"
                  class="mr-1"
                  v-c-tooltip.hover.click="$store.state.table.tooltipHapus"
                  v-b-modal.modal-delete
                  @click="data = item"
                  :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                  ><CIcon name="cil-trash" /> {{ item.actions }}</b-button
                >
              </td>
            </template>
          </CDataTable>
          <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
        </CCol>
      </CRow>
    </CCol>
    <modal-input :divisi="listDivisi" @alertFromChild="triggerAlert($event)" />
    <modal-edit :data="data" :divisi="listDivisi" :edit="edit" @alertFromChild="triggerAlert($event)" />
    <modal-delete :data="data" @alertFromChild="triggerAlert($event)" />
  </CRow>
</template>

<script>
import modalInput from "./modalInput.vue";
import modalEdit from "./modalEdit.vue";
import modalDelete from "./modalDelete.vue";

export default {
  components: {
    modalInput,
    modalEdit,
    modalDelete,
  },
  props: ["activeTab"],
  name: "Posisi",
  data() {
    return {
      edit: false,
      listDivisi: [],
      data: {},
      items: [],

      options: [
        {
          tipe: "Tetap",
          pilihan: [
            { value: 1, text: "Komisaris" },
            { value: 2, text: "Direksi" },
            { value: 3, text: "Manajer - Tetap" },
            { value: 4, text: "Kasie - Tetap" },
            { value: 5, text: "Staf - Tetap" },
            { value: 6, text: "Mekanik - Tetap" },
            { value: 7, text: "Pengemudi - Tetap" },
            { value: 8, text: "Kebersihan & Taman - Tetap" },
          ],
        },
        {
          tipe: "Kontrak",
          pilihan: [
            { value: 11, text: "Manajer - Kontrak" },
            { value: 12, text: "Staf - Kontrak" },
            { value: 13, text: "Supervisi & Koordinator Cabang - Kontrak" },
            { value: 14, text: "Operator Telepon - Kontrak" },
            { value: 15, text: "Mekanik - Kontrak" },
            { value: 16, text: "Pengemudi - Kontrak" },
            { value: 17, text: "Pesuruh - Kontrak" },
            { value: 18, text: "Petugas Kebersihan - Kontrak" },
            { value: 19, text: "Petugas Parkir & Koordinator - Kontrak" },
            { value: 20, text: "Petugas Taman - Kontrak" },
            { value: 21, text: "Satpam - Kontrak" },
          ],
        },
        {
          tipe: "Borongan",
          pilihan: [{ value: 22, text: "Petugas Kebersihan - Borongan" }],
        },
        {
          tipe: "Bank Jateng",
          pilihan: [
            { value: 31, text: "Call Center - Bank Jateng" },
            { value: 32, text: "Mekanik - Bank Jateng" },
            { value: 33, text: "Pengemudi - Bank Jateng" },
            { value: 34, text: "Pesuruh - Bank Jateng" },
            { value: 35, text: "Satpam - Bank Jateng" },
          ],
        },
        {
          tipe: "Mitra",
          pilihan: [{ value: 41, text: "Satpam - Mitra" }],
        },
      ],
      filter: {},
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    fields() {
      let x = [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaDivisi",
          label: this.$store.state.table.divisi,
          _style: "max-width: 70%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "kodePosisi",
          label: this.$store.state.table.kode,
          _style: "width: 20%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        // {
        //   key: "namaDivisi",
        //   label: "Divisi",
        //   _style: "width: 40%;",
        //   sortDirection: "desc",
        //   class: "text-left",
        //   sorter: false,
        // },
        {
          key: "namaPosisi",
          label: this.$store.state.table.posisi,
          _style: "max-width: 70%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: "Actions",
          _style: "width: 10%;",
          class: "text-center",
          filter: false,
          sorter: false,
        },
      ];
      if (this.$store.state.role_aktif.kodeRole == "super") {
        x.splice(1, 0, {
          key: "namaMitra",
          label: "Mitra",
          _style: "width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        });
      }
      return x;
    },
  },
  mounted() {
    this.getDatas();
    this.getDivisi();
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    activeTab: function (newVal) {
      if (newVal == 1) {
        this.getDatas();
        this.getDivisi();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = x;
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listPosisi = await vm.$axios.post("masterPosisi/listPerHalaman", {
        ...vm.filter,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      // console.log("listPosisi", listPosisi);
      vm.items =
        listPosisi.data.status == 200
          ? listPosisi.data.data.map((x, idx) => {
              for (let a = 0; a < vm.options.length; a++) {
                const elA = vm.options[a];
                for (let b = 0; b < elA.pilihan.length; b++) {
                  const elB = elA.pilihan[b];
                  if (elB.value == x.kodePosisi) {
                    x.namaKode = elB.text;
                  }
                }
              }
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                id: x.masterPosisiId,
                namaMitra: x.namaMitra || " - ",
              };
            })
          : [];
      // for (let i = 0; i < vm.items.length; i++) {
      //   let x = vm.items[i];
      //   x.no = i + 1;

      //   for (let a = 0; a < vm.options.length; a++) {
      //     const elA = vm.options[a];
      //     for (let b = 0; b < elA.pilihan.length; b++) {
      //       const elB = elA.pilihan[b];
      //       if (elB.value == x.kodePosisi) {
      //         x.namaKode = elB.text;
      //       }
      //     }
      //   }
      // }
      vm.totalRows = parseInt(listPosisi.data.count);
      vm.loading = false;
    },
    async getDivisi() {
      let vm = this;
      let listDivisi = await vm.$axios.post("masterDivisi/list");
      // console.log('listDivisi : ', listDivisi)
      vm.listDivisi =
        listDivisi.data.status == 200
          ? listDivisi.data.data.map((x) => {
              return {
                ...x,
                id: x.masterDivisiId,
              };
            })
          : [];
    },
    triggerAlert(event) {
      let vm = this;
      vm.getDatas();
      vm.$store.commit("set_alert", event);
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
